const programTypes = Object.freeze({
    groupMemberships: 1
});
export const programTypesNamesMap = Object.freeze({
    [programTypes.groupMemberships]: 'Group Memberships'
});
export default programTypes;
